export function updateFilter({ filterType, filterValue }) {
  return {
    type: 'UPDATE_FILTER',
    filterType: filterType,
    filterValue: filterValue,
  };
}
